import React, { useState } from "react";
import { useTracking } from "../../hooks/useTracking";
import { saveUserProfile } from "../../helper/userProfile";
import PerfilUsuario from "../PerfilUsuario/PerfilUsuario";

// Pide sexo y edad antes de mostrar el contenido, cada vez que se entra
const RequierePerfil = ({ children, navTarget, ubicacion }) => {
  const { trackEvent } = useTracking();

  const [perfilCompleto, setPerfilCompleto] = useState(false);

  const handleContinuar = ({ sexo, edad }) => {
    saveUserProfile({ sexo, edad });

    trackEvent("user_profile_submit", {
      user_sexo: sexo,
      user_edad: edad,
      nav_target: navTarget,
      ubicacion
    });

    setPerfilCompleto(true);
  };

  if (!perfilCompleto) {
    return <PerfilUsuario onContinuar={handleContinuar} />;
  }

  return children;
};

export default RequierePerfil;
